import React, {Component} from 'react';

export default class Loader extends Component {
    render() {
        return (
            <div className="page-loader">
                <span className="loader"></span>
            </div>
        );
    }
}
